<template>
    <div class="file-frame">
        <div class="file-val clearfix">
            <div class="file-item" v-for="(item,index) in fileList" :key='index'>
                <div class="file-download">
                    <img :src="item">
                    <div class="file-l" @click="imgDelete(index)">删除</div>
                </div>
            </div>
            <div class="img-loading" v-show="loading"><img src="../assets/images/icon/load.gif"></div>
            <div class="file-btn" @click="changeFile" v-if="fileList.length<5">
                <img src="../assets/images/icon/add.png">
                <input :type="type" accept="image/jpeg,image/png,image/jpg" class="file-i-e" @change='fileUpload()'>
            </div>
        </div>
    </div>
</template>

<script>
    import {get_qiniu_token, toQiniu} from '../api/open/new'
    export default {
        name: "fileDome",
        props: ["imgList"],
        data () {
            return {
                upToken: '',//七牛token
                domain: '',//图片链接baseurl
                loading : false,
                fileList : [],
                type : "file",
            }
        },
        methods:{
            changeFile(){
                this.type = "file";
            },
            fileUpload(){
                let certificateBackImg = document.getElementsByClassName('file-i-e');
                let img = certificateBackImg[0].files[0];
                if(img.type.indexOf("image")){
                    alert("请上传图片");
                    return false
                }
                if(img.size> 5*1024*1024){
                    alert("图片大于5MB");
                    return false
                }
                let binary = new FormData()
                binary.append('file',img);
                this.loading = true;
                this.type = "text";
                get_qiniu_token().then(res => {
                    this.type = "file";
                    let data = res.data
                    if (data.code === '000') {
                        this.upToken = data.content.upToken;
                        this.domain = data.content.domain;
                        binary.append('token', this.upToken);
                        this.updataQiniu(binary);
                    }
                }).catch(err => {
                    this.type = "file";
                    this.loading = false;
                    console.log(err);
                })
                this.$emit('imgData',this.fileList)

            },
            //上传到七牛
            updataQiniu(para) {
                toQiniu(para).then(res => {
                    this.loading = false;
                    let data = res.data;
                    let arrText = {};
                    arrText = 'https://' + this.domain + '/' + data.key;
                    if(this.fileList.length>=5){
                        alert("超过上传数量上限");
                        return;
                    }
                    this.fileList.push(arrText);

                }).catch(err => {
                    this.loading = false;
                    console.log(err);
                })
            },
            imgDelete(num){
                this.fileList.splice(num,1);
            }
        },
        created(){
        },
    }
</script>
<style scoped lang='scss'>
    .file-frame{
        .img-loading{
            float: left;
            height: 20px;
            padding: 8px 0;
            line-height: 20px;
            margin-right: 10px;
            img{
                width: 20px;
                height: 20px;
            }
        }
        .file-item{
            float: left;
            margin-right: 20px;
            position: relative;
            border-radius: 5px;
            // border: 1px solid #adadad;
            width: 70px;
            height: 70px;
            margin-bottom: 15px;
            .file-download{
                width: 100%;
                height: 100%;
                img{
                    display: block;
                    width: 100%;
                    height: 100%;
                }
            }
            .file-l{
                position: absolute;
                text-align: center;
                font-size: 12px;
                color: #fff;
                line-height: 20px;
                cursor: pointer;
                right: 0;
                top: 0;
                padding: 0 10px;
                background-color: #2D74FD;
            }
        }
        .file-btn{
            float: left;
            position: relative;
            width: 30px;
            height: 30px;
            padding: 20px;
            line-height: 30px;
            text-align: center;
            // border: 1px solid #adadad;
            background-color: white;
            border-radius: 5px;
            color: #adadad;
            cursor: pointer;
            margin-bottom: 10px;
            img{
                display: block;
                width: 30px;
                height: 30px;
            }
            input{
                position: absolute;
                width: 100%;
                left: 0;
                top: 0;
                opacity: 0;
                height: 100%;
                cursor: pointer;
            }
        }
    }
</style>

